import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-join-us-to-invite-modal",
  templateUrl: "./join-us-to-invite-modal.component.html",
  styleUrls: ["./join-us-to-invite-modal.component.scss"],
  standalone: false,
})
export class JoinUsToInviteModalComponent {
  constructor(public dialogRef: MatDialogRef<JoinUsToInviteModalComponent>) {}

  ngOnInit() {}

  redirectToLogin() {
    this.closeModal({ redirect: true });
  }
  closeModal(body: any = {}) {
    this.dialogRef.close(body);
  }
}
